import api from '../utils/api';
import Session, { IS_LO } from './Session';

const getClientSettings = async () => {
  let clientSettings = [];
  if (Session.get(IS_LO)) {
    clientSettings = await api.getWebhookLookups('clientsettings');
  }

  return clientSettings;
};

export const getClientSettingsData = async () => {
  try {
    const clientSettings = await getClientSettings();
    let settings = {};
    if (Array.isArray(clientSettings) && clientSettings.length) {
      const { options = {} } = clientSettings[0] || {};
      settings = options;
    }
    return settings;
  } catch (error) {
    return false;
  }
};

export const getZeroBasedPricing = async (channel: number) => {
  try {
    const response = await api.getZeroBasedPricing(channel);
    if ((response as Response)?.status) {
      throw new Error((response as Response)?.status.toString());
    }
    return response;
  } catch (error) {
    console.error('Error fetching zero based par pricing settings:', error);
    throw new Error('Failed to fetch zero based par pricing');
  }
};
